module.exports = __webpack_public_path__ + "media/images/flags/16/Kazakhstan-87f7afb295265b06eaeca8cbd863021c.png";